module.exports = {"id":"225201","name":"Alex Berenguer","rating":"75","photo":"./data/images/photos/4/225201.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["AG","DLG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexBerenguer0.json
// module id = 204
// module chunks = 0